import React, { useEffect, useState, useCallback } from 'react';
import { Box, Tabs, Tab, Grid, Typography, Select, MenuItem } from '@mui/material';
import styled from '@emotion/styled';
import '../css/AnnouncementBoard.css'; // Import the CSS file
import Orders from './orders';
import banner from '../imgs/DuvelUSA_BeerPortal_Banner_1.jpg';
import PreOrders from './preOrders';
import { useApiBaseUrl } from '../context/ApiContext';
import FAQ from './faq';
import ContactPage from './contacts';
import Reports from './reports';
import Admin from './admin';

const StyledTab = styled(Tab)(({ theme }) => ({
  color: 'grey',
  '&.Mui-selected': {
    color: 'red',
    borderBottom: '2px solid red',
  },
}));




const Header = ({ version, username, isAdmin, SelectedCustomer, handleImpersonationChange, showAdmin, handleGoToAdmin, handleGoBackToDashboard }) => {
  const ApiBaseUrl = useApiBaseUrl();
  const [logisticsContacts, setLogisticsContacts] = useState([]);

    
  useEffect(() => {
    fetch(`${ApiBaseUrl}/api/Sales/GetAllLogisticsContacts`)
      .then(response => response.json())
      .then(data => {
      console.log("Logistics contacts data:", data);
      setLogisticsContacts(data);
    })
    .catch(error => console.error('Error fetching logistics contacts:', error));
  }, []);

    //handleImpersonation
    const handleImpersonation = (contactId) => {
      console.log('Selected contact ID:', contactId);
      handleImpersonationChange(contactId);
    };


    const handleAdmin = () => {
      showAdmin ? handleGoBackToDashboard() : handleGoToAdmin();
    };

  return (
  <Box component="header" sx={{ height: '122px', width: '100%', backgroundColor: 'whitesmoke' }}>
    <Grid container spacing={2}>
      <Grid item xs={2}>
        {/* {isAdmin && (
          <Typography sx={{ float: 'left', pl: 2, pt: 1, color: 'red', cursor: 'pointer' }}>
            Admin
          </Typography>
        )} */}
        
        <div style={{position: 'absolute', top: '4px', left: '4px', fontSize: '12px'}}>version: {version ? version : null}</div>
        <div style={{position: 'absolute', top: '20px', left: '4px', cursor: 'pointer'}}>
          
          <a style={{color: 'red'}} onClick={() => handleAdmin()}>
            {isAdmin ? (showAdmin ? 'Exit Admin' : 'Admin') : null}
          </a>
        
        </div>
        {!showAdmin && SelectedCustomer && SelectedCustomer.customerNo_ && SelectedCustomer.customerName ? (
          <div style={{ position: 'absolute', top: '110px', left: '16px' }}>
            {SelectedCustomer.customerNo_} - {SelectedCustomer.customerName}
          </div>
        ) : null}
      </Grid>
      <Grid item xs={8}>
        {/* Middle column content */}
        <img src={banner} alt="Banner Image Duvel USA Beer Portal" style={{ width: '100%', height: '106px' }} />
      </Grid>
      <Grid item xs={2} sx={{ pr: 2 }}>
        <Typography sx={{ textAlign: 'right' }}>{username}</Typography>
        {isAdmin && (
          <>
            {!showAdmin && (
              <>
                <Typography sx={{ textAlign: 'right', mt: 1 }}>Impersonation</Typography>
                <select style={{width: '200px', float: 'right', marginTop: '4px'}}
                    onChange={(e) => handleImpersonation(e.target.value)}>
                    <option value="">Select to impersonate</option>
                    {logisticsContacts.map((contact) => (
                      <option key={contact.mail+'_'+contact.displayName} value={contact.mail}>{contact.displayName} - ({contact.mail})</option>
                    ))}
                </select>
              </>
            )}
          </>
        )}
      </Grid>
    </Grid>
  </Box>
  );
};

const NavigationTabs = ({ SelectedNavTab, handleChange }) => (
  <Box sx={{ backgroundColor: 'whitesmoke', borderTop: '1px lightgrey solid', boxShadow: '0px 4px 10px -3px #858585' }}>
    <Tabs value={SelectedNavTab} onChange={handleChange} centered TabIndicatorProps={{ style: { backgroundColor: 'red' } }}>
      <StyledTab label="DASHBOARD" sx={{ fontSize: '1.2rem' }} />
      <StyledTab label="ORDERS" sx={{ fontSize: '1.2rem' }} />
      <StyledTab label="PREORDERS" sx={{ fontSize: '1.2rem' }} />
      <StyledTab label="REPORTS" sx={{ fontSize: '1.2rem' }} />
      <StyledTab label="FAQ" sx={{ fontSize: '1.2rem' }} />
      <StyledTab label="CONTACT" sx={{ fontSize: '1.2rem' }} />
    </Tabs>
  </Box>
);

const ThreeColumnGrid = ({ username, customers, handleCustomerChange, SelectedCustomerId, handleSelectOrder }) => (
  <Grid container sx={{ height: '100vh' }}>
    <Grid item xs={4} sx={{ border: '1px solid lightgrey', height: '100%',
                            padding: '16px', paddingTop: '32px',  }}>
      <CustomerSelection username={username} customers={customers} handleCustomerChange={handleCustomerChange} SelectedCustomerId={SelectedCustomerId} />
      <AnnouncementBoard />
    </Grid>
    <Grid item xs={4} sx={{ border: '1px solid lightgrey', height: '100%' }}>
      {/* Main content */}
      <OrderSummaries SelectedCustomerId={SelectedCustomerId} handleSelectOrder={handleSelectOrder} />
    </Grid>
    <Grid item xs={4} sx={{ border: '1px solid lightgrey', height: '100%' }}>
      {/* Main content */}
      <PreOrderSummaries SelectedCustomerId={SelectedCustomerId} />
    </Grid>
  </Grid>
);


const PreOrderSummaries = ({ customerId, SelectedCustomerId }) => {
  const ApiBaseUrl = useApiBaseUrl();
  const [PreOrderSummaries, setPreOrderSummaries] = useState([]);

  useEffect(() => {
    const fetchPreOrderSummaries = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/${SelectedCustomerId}/GetPreOrderSummary_ByCustomerId`);
        const data = await response.json();
        const sortedPreOrderSummaries = [...data.data].sort((a, b) => new Date(a.firstShipDate) - new Date(b.firstShipDate));
        setPreOrderSummaries({ data: sortedPreOrderSummaries, message: data.message, success: data.success });
      } catch (error) {
        console.error('Error fetching pre order summaries:', error);
      }
    };

    if (SelectedCustomerId) {
      fetchPreOrderSummaries();
    }
  }, [SelectedCustomerId]);

  return (
    <div className="order-summaries" style={{ background: 'white', border: 'solid 1px', marginTop: '16px' }}>
      <h2>Pre Order History</h2>
      <div className="order-summary">
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Description</th>
              <th>Due Date</th>
              <th>Ship date</th>
              <th>Qty</th>
            </tr>
          </thead>
          <tbody>
            {PreOrderSummaries.data && PreOrderSummaries.data.length > 0 ? 
              PreOrderSummaries.data.map((order, index) => (
              <tr key={index}>
                <td style={{ textAlign: 'left', paddingLeft: '8px' }}>{order.description}</td>
                <td>{new Date(order.preorderDueDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'})}</td>
                <td>{new Date(order.firstShipDate).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'})}</td>
                <td style={order.preOrderQty === 0 ? { color: 'lightgrey', fontStyle: 'italic' } : { fontWeight: 'bold' }}>
                  {order.preOrderQty}
                </td>
              </tr>
            )) : (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center' }}>
                  {PreOrderSummaries.message || 'No pre-orders found'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const CustomerSelection = ({ username, customers, handleCustomerChange, SelectedCustomerId }) => {
  
  return (<Box sx={{ padding: '16px', position: 'relative', backgroundColor: 'white', height: '64px', boxShadow: '0px 4px 10px -3px #858585' }}>
    <Typography sx={{ float: 'left', textAlign: 'left', marginTop: '8px', width: '100%' }}>
      Welcome, {username}
    </Typography>
    <select
      style={{ width: '100%', float: 'right', marginTop: '8px' }}
      value={SelectedCustomerId}
      onChange={handleCustomerChange}
    >
      <option value="" disabled>Select a customer</option>
      {customers.map((customer) => (
        <option key={customer.customerNo_} value={customer.customerNo_}>
          {customer.customerNo_} {customer.customerName}
        </option>
      ))}
    </select>
    {/* <select style={{ width: '260px', float: 'right', marginTop: '8px' }} defaultValue="">
      {customers.map((customer) => (
        <option key={customer.customerNo_} value={customer.customerNo_}>
          {customer.customerNo_} {customer.customerName}
        </option>
      ))}
    </select> */}
  </Box>)
};

const AnnouncementBoard = () => {
  const announcements = [
    {
      title: "PRE-ORDER ITEMS DUE February 7",
      categories: [
        {
          name: "BOULEVARD:",
          items: [
            "Teal Rising - 6-pack bottle (KC Only)",
            "Fancy Livin' - 6-pack can and draft"
          ]
        },
        {
          name: "OMMEGANG:",
          items: [
            "NONE"
          ]
        },
        {
          name: "IMPORTS:",
          items: [
            "NONE"
          ]
        }
      ]
    },
    {
      title: "NEW/RETURNING ITEMS TO PLACE FIRST ORDER (Due February 7)",
      categories: [
        {
          name: "BOULEVARD:",
          items: [
            "Space Camper Chillbreak Endless IPA - 6-pack can",
            "Space Camper Non-Alc IPA - 6-pack can",
            "Boulevard Light - 12-pack and 24-pack cans; 6-pack bottle and draft",
            "Boulevard Space Camper Cosmic Mix Variety 1H25 - 12-pack variety (Space Camper Cosmic IPA, Chillbreak IPA, Crater Raider)"
          ]
        },
        {
          name: "OMMEGANG:",
          items: [
            "NONE"
          ]
        },
        {
          name: "IMPORTS:",
          items: [
            "La Chouffe (domestic keg) 1/6 bbl keg"
          ]
        }
      ]
    },
    {
      title: "PAST PRE-ORDERED ITEMS SHIPPING ON March 2025 ORDERS (Due February 7)",
      categories: [
        {
          name: "BOULEVARD:",
          items: [
            "Quirk Blueberry Slam - 12-pack can and draft",
            "Crown Town Ale - 6-pack can and draft",
            "Tropic Slam - 6-pack can and draft"
          ]
        },
        {
          name: "OMMEGANG:",
          items: [
            "NONE"
          ]
        },
        {
          name: "IMPORTS:",
          items: [
            "NONE"
          ]
        }
      ]
    }
  ];
  return (
    <div className="announcement-board" style={{background: 'white', border: 'solid 1px', marginTop: '16px'}}>
      <h2>Announcements</h2>
      {announcements.map((announcement, index) => (
        <div key={index} className="announcement">
          <h3>{announcement.title}</h3>
          {announcement.categories.map((category, catIndex) => (
            <div key={catIndex} className="category">
              <h4>{category.name}</h4>
              {category.items.length > 0 ? (
                <ul>
                  {category.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              ) : (
                <p>NONE</p>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};


const OrderSummaries = ({ customerId, SelectedCustomerId, handleSelectOrder }) => {
  const [orderSummaries, setOrderSummaries] = useState([]);
  const ApiBaseUrl = useApiBaseUrl();

  const handleRowClick = (orderNo) => {
    //alert(`Selected Order No: ${orderNo}`);
    handleSelectOrder(orderNo);
  };

  useEffect(() => {
    const fetchOrderSummaries = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Sales/${SelectedCustomerId}/GetOrderSummaries_ByCustomerId`);
        const data = await response.json();
        const sortedOrderSummaries = [...data.data]
          //.filter(order => order.totalWeight !== 0)
          .sort((a, b) => new Date(a.estimatedShipmentDate) - new Date(b.estimatedShipmentDate));
        setOrderSummaries({ data: sortedOrderSummaries, message: data.message, success: data.success });
        console.log('orderSummaries retrieved from GetOrderSummaries_ByCustomerId:', sortedOrderSummaries);
      } catch (error) {
        console.error('Error fetching order summaries:', error);
      }
    };
    if (SelectedCustomerId != '') {
      fetchOrderSummaries();
    }
  }, [SelectedCustomerId]);

  return (
    <div className="order-summaries" style={{ background: 'white', border: 'solid 1px', marginTop: '16px', maxHeight: '800px' }}>
      <h2>Order History</h2>
      <div className="order-summary">
        <table style={{ width: '100%' }}>
          <thead>
            <tr>
              <th>Purchase No.</th>
              <th>Order No</th>
              <th>Ship Date</th>
              <th>Status</th>
              <th>Weight</th>
            </tr>
          </thead>
          <tbody>
            {orderSummaries.data && orderSummaries.data.length > 0 ? (
              orderSummaries.data.map((order, index) => (
                <tr key={index}
                    onClick={() => handleRowClick(order.orderNo)}
                    style={{
                      backgroundColor: 'inherit', 
                      transition: 'background-color 0.3s', 
                      cursor: 'pointer' 
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'inherit'}
                >
                  <td>{order.custOrderNo}</td>
                  <td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {order.orderNo}
                  </td>
                  <td style={{ textAlign: 'left', paddingLeft: '20px' }}>
                    {new Date(order.estimatedShipmentDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit'
                    })}
                  </td>
                  <td>{order.status === 0 ? "Open" : order.status === 1 ? "Ready" : ""}</td>
                  <td style={{ textAlign: 'right' }}>{order.totalWeight} lbs</td>
                </tr>
                ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center' }}>
                  {orderSummaries.message || 'No order summaries found'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

function Dashboard({ version, username, isAdmin }) {
  const [SelectedNavTab, setSelectedNavTab] = React.useState(0);
  const [SelectedOrderId, setSelectedOrderId] = React.useState('');
  const [showAdmin, setShowAdmin] = useState(false);

  const handleGoToAdmin = () => {
    setShowAdmin(true);
  };

  const handleGoBackToDashboard = () => {
    setShowAdmin(false);
  };
  
  const ApiBaseUrl = useApiBaseUrl();

  const handleNavChange = (event, selectedNavTab) => {
    setSelectedNavTab(selectedNavTab);
    if (selectedNavTab !== 1) {
      setSelectedOrderId('');
    }
  };

  
  const handleSelectOrder = (orderId) => {
    console.log('Selected order:', orderId);
    setSelectedOrderId(orderId);
    handleNavChange(null, 1);
    //alert(`Selected order asdfdsf: ${orderId}`);
  };

  const handleSetNewOrderId = (orderId) => {
    setSelectedOrderId(orderId);
    handleNavChange(null, 1);
  };



  const [SelectedCustomerId, setSelectedCustomerId] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const handleCustomerChange = (event) => {
    setSelectedCustomerId(event.target.value);
    console.log('Selected customer ID:', event.target.value);
    const customer = customers.find(cust => cust.customerNo_ === event.target.value);
    setSelectedCustomer(customer);
    console.log('Selected customer:', customer);
    //alert(`Selected customer: ${event.target.value}`);
  };

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  //GetAssociatedCustomers_ByEmail
  useEffect(() => { 
    const fetchCustomers = async () => {
      try {
        const email = username;
        const response = await fetch(`${ApiBaseUrl}/api/Users/${email}/GetAssociatedCustomers_ByEmail`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setCustomers(data);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    if (username) {
      fetchCustomers();
    }
  }, [username]);

  //need state var for the impersonated user
  const [impersonatedUser, setImpersonatedUser] = useState(null);
  //useEffect dependent on impersonatedUser
  useEffect(() => {
    console.log('Impersonated user:', impersonatedUser);
    //fetch customers from the api
    const fetchCustomers = async () => {
      try {
        const response = await fetch(`${ApiBaseUrl}/api/Users/${impersonatedUser}/GetAssociatedCustomers_ByEmail`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setCustomers(data);
      } catch (error) {
        setError(error);
      }
    };
    if (impersonatedUser) {
      fetchCustomers();
    }
  }, [impersonatedUser]);

  //accept the username changed as an impersonation. as a handler function
  const handleImpersonationChange = useCallback((username) => {
    console.log('Selected username/email:', username);
    setImpersonatedUser(username);
    setSelectedCustomer(null);
    setSelectedCustomerId('');
  }, []);

  const handleOrderDeleted = () => {
    setSelectedOrderId('');
    //handleNavChange(null, 0);
    //setSelectedNavTab(0);
    alert('Order deleted');
  };

  const renderContent = () => {
    if (showAdmin) {
      return <Admin onGoBack={handleGoBackToDashboard} />;
    } else {
    switch (SelectedNavTab) {
      case 0:
        return <ThreeColumnGrid username={username} customers={customers} handleCustomerChange={handleCustomerChange} SelectedCustomerId={SelectedCustomerId} handleSelectOrder={handleSelectOrder} />;
      case 1:
        return <Orders SelectedCustomerId={SelectedCustomerId} SelectedOrderId={SelectedOrderId} handleSetNewOrderId={handleSetNewOrderId} usernameEmail={username} handleOrderDeleted={handleOrderDeleted} handleRowClick={handleSelectOrder}></Orders>;
      case 2:
        return <PreOrders selectedCustomerId={SelectedCustomerId} usernameEmail={username} />;
      case 3:
        return <Reports selectedCustomerId={SelectedCustomerId} usernameEmail={username} />;  
      case 4:
        return <FAQ />;
      case 5:
        return <ContactPage selectedCustomerId={SelectedCustomerId} usernameEmail={username} />;
      default:
        return null;
    }}
  };

  return (
    <Box sx={{ height: '93vh' }}>
      <Header version={version} username={username} isAdmin={isAdmin} SelectedCustomer={selectedCustomer} handleImpersonationChange={handleImpersonationChange}
              showAdmin={showAdmin} handleGoToAdmin={handleGoToAdmin} handleGoBackToDashboard={handleGoBackToDashboard} />
      {!showAdmin && (
        <NavigationTabs SelectedNavTab={SelectedNavTab} handleChange={handleNavChange} SelectedCustomerId={SelectedCustomerId} />
      )}
      
      {renderContent()}
      {/* <ThreeColumnGrid username={username} customers={customers} handleCustomerChange={handleCustomerChange} SelectedCustomerId={SelectedCustomerId} /> */}
 
      
    </Box>
  );
};

export default Dashboard;